import { useState } from "react";

type TTime = {
  time: number;
};
export const useLoadingHome = ({ time }: TTime) => {
  const [isLoadingHome, setIsLoadingHome] = useState<boolean>(false);

  const loading = () => {
    setIsLoadingHome(true);
    setTimeout(() => {
      setIsLoadingHome(false);
    }, time);
  };
  return { loading, isLoadingHome, setIsLoadingHome };
};
